import React from "react";
import { Chip } from "@mui/material";
import { CheckCircle2, Clock, AlertTriangle, FileQuestion } from "lucide-react";

const StatusBadge = ({ status }) => {
  if (status === null || status === undefined || status === "" || String(status).toLowerCase() === "null") {
    return (
      <Chip
        icon={<FileQuestion size={13} color="#64748b" />}
        label="Not Uploaded"
        size="small"
        sx={{
          height: "22px",
          fontSize: "0.72rem",
          fontWeight: 600,
          backgroundColor: "#f1f5f9",
          color: "#64748b",
          border: "1px solid #e2e8f0",
          borderRadius: "6px",
          "& .MuiChip-label": { px: 0.75 }
        }}
      />
    );
  }

  const normalized = String(status).trim().toLowerCase();

  switch (normalized) {
    case "approved":
    case "accepted":
      return (
        <Chip
          icon={<CheckCircle2 size={13} color="#166534" />}
          label={normalized === "accepted" ? "Accepted" : "Approved"}
          size="small"
          sx={{
            height: "22px",
            fontSize: "0.72rem",
            fontWeight: 700,
            backgroundColor: "#dcfce7",
            color: "#166534",
            border: "1px solid #bbf7d0",
            borderRadius: "6px",
            "& .MuiChip-label": { px: 0.75 }
          }}
        />
      );
    case "rejected":
      return (
        <Chip
          icon={<AlertTriangle size={13} color="#991b1b" />}
          label="Rejected"
          size="small"
          sx={{
            height: "22px",
            fontSize: "0.72rem",
            fontWeight: 700,
            backgroundColor: "#fee2e2",
            color: "#991b1b",
            border: "1px solid #fecaca",
            borderRadius: "6px",
            "& .MuiChip-label": { px: 0.75 }
          }}
        />
      );
    case "changes_requested":
      return (
        <Chip
          icon={<AlertTriangle size={13} color="#991b1b" />}
          label="Changes Requested"
          size="small"
          sx={{
            height: "22px",
            fontSize: "0.72rem",
            fontWeight: 700,
            backgroundColor: "#fee2e2",
            color: "#991b1b",
            border: "1px solid #fecaca",
            borderRadius: "6px",
            "& .MuiChip-label": { px: 0.75 }
          }}
        />
      );
    case "pending":
    case "pending review":
      return (
        <Chip
          icon={<Clock size={13} color="#9a3412" />}
          label="Pending"
          size="small"
          sx={{
            height: "22px",
            fontSize: "0.72rem",
            fontWeight: 700,
            backgroundColor: "#ffedd5",
            color: "#9a3412",
            border: "1px solid #fed7aa",
            borderRadius: "6px",
            "& .MuiChip-label": { px: 0.75 }
          }}
        />
      );
    default:
      return (
        <Chip
          label={status}
          size="small"
          sx={{
            height: "22px",
            fontSize: "0.72rem",
            fontWeight: 600,
            backgroundColor: "#eff6ff",
            color: "#1e40af",
            border: "1px solid #bfdbfe",
            borderRadius: "6px",
            "& .MuiChip-label": { px: 0.75 }
          }}
        />
      );
  }
};

export default StatusBadge;
